import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { AccountSetting } from "~/components/specifics/vendors/settings/accounts/AccountSetting";
import { ProfileSetting } from "~/components/specifics/vendors/settings/profiles/ProfileSetting";
import type { VendorSession } from "~/models/VendorSession";

type Props = {
	session: VendorSession;
};

export function Page({ session }: Props) {
	return (
		<VendorLayoutV2>
			<VendorSettingLayout spMenu>
				{session.vendorUser ? (
					<ProfileSetting loginVendorUser={session.vendorUser} />
				) : (
					<AccountSetting session={session} />
				)}
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
}
